<template>
  <div class="Tooltip_Reaction text-gray-400 mt-4 mb-4">
    <div class="flex">
      <ui-pictogram
        :user="comment.user"
        size="default"
        class="mr-3 !bg-green-600 !text-white"
      />

      <div class="leading-tight flex-grow">
        <div class="text-sm">
          {{ comment.user.name }}
          {{ comment.user.surname }}
        </div>
        <div class="text-xs">
          {{ date(comment.created) }}
        </div>
      </div>

      <div
          class="px-1 py-1 hover:bg-gray-100 cursor-pointer leading-tight"
          v-if="comment.user.id === $presenter.identity.id && !comment.done"
          @click.prevent.stop="switchEdit()"
      >
        <aw-icon
          icon="pen"
          class="relative w-4 h-4  text-gray-400"
          ></aw-icon>
      </div>
    </div>
    <div class="mt-1 leading-snug text-sm" v-show="!edit">
      {{ comment.comment_text }}
    </div>
    <div class="mt-1" v-if="edit">
      <textarea
        :placeholder="$t('Your comment')"
        class="w-full border-gray-400 rounded text-sm text-gray-800"
        v-model="commentText"
      ></textarea>
      <a href="#" class="btn btn-primary btn-xs mr-2" @click.stop.prevent="updateComment">{{$t('Update comment')}}</a>
      <a href="#" class="btn btn-secondary btn-xs" @click.prevent.stop="switchEdit()">{{$t('Cancel')}}</a>
    </div>
  </div>
</template>
<script>
import formatDate from 'nette-base-module/js/utils/formatDate'
import { DocumentApi } from '../../test-api/index.ts'
import findIndex from 'lodash/findIndex'
const documentApi = new DocumentApi({}, '/api/v2')
import handleApiError from '../../utils/handleApiError'

export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Array,
    comment: Object,
    element: Object,
    document: Object,
  },
  data() {
    return {
      edit: false,
      commentText: this.modelValue.comment_text
    }
  },
  computed: {
    allComments: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    },
  },
  methods: {
    date(date) {
      return formatDate(date, 'j.n.Y - H:i')
    },
    async updateComment() {
      const comment = {
        comment_text: this.commentText,
      }

      const updateCommentResponse = await handleApiError(() => documentApi.elementUpdateComment(
        this.document.id,
        this.document.bc_document_rev_id,
        this.element.bc_document_rev_id ? this.element.id : this.element.from__bc_document_data_rev_id, // comments in revisions vs pusblished document
        this.comment.id,
        comment
      ))

      this.edit = false
      const index = findIndex(this.allComments, ['id', this.comment.id])
      this.allComments[index] = updateCommentResponse.data
    },
    switchEdit() {
      this.edit = !this.edit
      if (!this.edit) {
        return
      }

      this.commentText = this.comment.comment_text
    }
  }
}
</script>
<style lang="scss" scoped>

</style>